import React from 'react';
import { MenuItem, Stack, TextField, Typography } from '@mui/material';
import { answerLabel } from './editorModel';

/**
 * Die offenen Fragen eines Dokumentplans (#1245) — im Probelauf der Verwaltung und in »Urkunde in
 * DiNo erstellen« (Teil 48) dieselbe Darstellung: eine Auswahl, wo der Plan Antworten vorgibt,
 * sonst ein Textfeld.
 */

export interface IPlanQuestion {
  kind: string;
  key: string;
  prompt: string;
  options?: { label: string; answer: string }[];
  answerType?: string;
  helpText?: string | null;
}

interface Props {
  questions: IPlanQuestion[];
  answers: Record<string, string>;
  onAnswer: (_key: string, _value: string) => void;
  disabled?: boolean;
  /** Schmale Spalte: Frage über der Antwort statt daneben. */
  stacked?: boolean;
}

export const PlanQuestions: React.FC<Props> = ({
  questions,
  answers,
  onAnswer,
  disabled,
  stacked,
}) => (
  <Stack spacing={1.5}>
    {questions.map(question => (
      <Stack
        key={question.key}
        direction={stacked ? 'column' : 'row'}
        spacing={stacked ? 0.75 : 2}
        alignItems={stacked ? 'stretch' : 'center'}
        sx={{ flexWrap: 'wrap', gap: stacked ? 0 : 1 }}
      >
        <Typography
          variant='body2'
          sx={{ flexGrow: 1, minWidth: stacked ? 0 : 260 }}
        >
          {question.prompt}
        </Typography>
        {question.helpText && (
          <Typography variant='caption' color='text.secondary'>
            {question.helpText}
          </Typography>
        )}
        {question.options && question.options.length > 0 ? (
          <TextField
            size='small'
            select
            label='Antwort'
            value={answers[question.key] ?? ''}
            disabled={disabled}
            onChange={event => onAnswer(question.key, event.target.value)}
            sx={{ minWidth: 200 }}
          >
            {question.options.map(option => (
              <MenuItem key={option.answer} value={option.answer}>
                {answerLabel(option.label)}
              </MenuItem>
            ))}
          </TextField>
        ) : (
          <TextField
            size='small'
            label='Antwort'
            defaultValue={answers[question.key] ?? ''}
            disabled={disabled}
            onBlur={event => onAnswer(question.key, event.target.value)}
            sx={{ minWidth: 200 }}
          />
        )}
      </Stack>
    ))}
  </Stack>
);
